import React, { useState } from 'react';
import styled from 'styled-components';

import PaletteColors from './palette-colors';

import { shuffle } from '../../helpers';

import HeartIcon from '../../../images/icons/heart.inline.svg';
import ShuffleIcon from '../../../images/icons/shuffle.inline.svg';

const palettes = [0, 1, 2, 3, 4, 5];

const PaletteContainer = styled.div`
    .header-links {
        display: flex;
        margin-bottom: 5px;
        .link {
            flex: 1;

            &:last-child {
                text-align: right;
            }

            button {
                font-size: 0.78rem;
                color: #000;
                text-decoration: none;
                background-color: transparent;
                border: none;
                span {
                    margin-right: 5px;

                    &.heart {
                        svg {
                            height: 15px;
                            width: 15px;
                            position: relative;
                            top: 3px;
                            stroke: #f74d33;
                            fill: #f74d33;
                        }
                    }
                    &.shuffle {
                        svg {
                            height: 15px;
                            width: 15px;
                            position: relative;
                            top: 3px;
                        }
                    }
                }
            }
        }
    }
    .palette-container {
        display: flex;
        padding: 0;
        margin: 0;
        list-style: none;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-flex-flow: row;
        justify-content: space-around;
        padding: 0 5px;
        line-height: 30px;

        button {
            background-color: #fff;
            margin-right: 5px;
            color: white;
            font-weight: bold;
            font-size: 1.5em;
            text-align: center;
            flex: 1 0 auto;
            height: auto;
            border: 1px solid #ccc;
            border-radius: 5px;
            position: relative;
            overflow: hidden;

            &:focus,
            &:active {
                outline: 0;
            }

            &::before {
                content: '';
                float: left;
                padding-top: 100%;
            }

            &:last-child {
                margin-right: 0px;
            }

            &.disabled {
                &::after {
                    content: '';
                    position: absolute;
                    border-top: 1px solid #ccc;
                    width: 140%;
                    left: 0;
                    transform: rotate(41deg);
                    transform-origin: 0% 0%;
                }
            }

            &.selected {
                border-color: #000;
            }
        }
    }
`;

const Palette = ({ currentPalette, setCurrentPalette }) => {
    const [paletteActive, setPaletteActive] = useState(0);

    let options = [
        'primary_color',
        'secondary_color',
        'accent_1',
        'accent_2',
        'accent_3',
        'accent_4',
    ];

    let amountOfColors = 3;

    function handleActivePaletteChange(index, avail) {
        if (!avail) {
            setPaletteActive(index);
        }
    }

    function findColorPal(index) {
        let currentPal = '';

        if (!index) {
            if (paletteActive === 0) {
                currentPal = 'primary_color';
            } else if (paletteActive === 1) {
                currentPal = 'secondary_color';
            } else if (paletteActive === 2) {
                currentPal = 'accent_1';
            } else if (paletteActive === 3) {
                currentPal = 'accent_2';
            } else if (paletteActive === 4) {
                currentPal = 'accent_3';
            } else if (paletteActive === 5) {
                currentPal = 'accent_4';
            }
        }
        return currentPal;
    }

    function addColorToPalette(color) {
        let currentPal = findColorPal();
        setCurrentPalette({
            ...currentPalette,
            [currentPal]: {
                name: color.colorname,
                code: color.rgbcode,
            },
        });
    }

    function shuffleColors() {
        // shuffles colors

        let colorArray = [];
        options.slice(0, amountOfColors).map((option) => {
            colorArray.push(currentPalette[option]);
        });

        colorArray = shuffle(colorArray);

        let newPalette = {};

        options.slice(0, amountOfColors).map((option, index) => {
            newPalette[option] = colorArray[index];
        });

        setCurrentPalette({
            ...currentPalette,
            ...newPalette,
        });
    }

    return (
        <PaletteContainer>
            <div className="header-links">
                <div className="link">
                    <button>
                        <span className="heart">
                            <HeartIcon />
                        </span>
                        Save this palette
                    </button>
                </div>
                <div className="link">
                    <button onClick={() => shuffleColors()}>
                        <span className="shuffle">
                            <ShuffleIcon />
                        </span>
                        Shuffle
                    </button>
                </div>
            </div>
            <div className="palette-container">
                {palettes.map((palette, index) => {
                    // display settings
                    let classes = [];
                    let isPaletteAvail =
                        index < amountOfColors ? '' : 'disabled';
                    let isPaletteActive =
                        index === paletteActive ? 'selected' : '';
                    classes.push(isPaletteAvail);
                    classes.push(isPaletteActive);
                    classes = classes.join(' ');

                    let currentPal = findColorPal(index);

                    console.log('here', currentPalette[options[index]]);
                    // find color
                    return (
                        <button
                            style={
                                currentPalette[options[index]] !== ''
                                    ? {
                                          backgroundColor:
                                              currentPalette[options[index]]
                                                  .code,
                                      }
                                    : {}
                            }
                            onClick={() =>
                                handleActivePaletteChange(index, isPaletteAvail)
                            }
                            className={classes}
                        ></button>
                    );
                })}
            </div>
            <PaletteColors addColorToPalette={addColorToPalette} />
        </PaletteContainer>
    );
};

export default Palette;
